import { configRoutes } from './config';
import { errorRoutes } from './error';

export const routes = {
  ...configRoutes,
  ...errorRoutes
};
